import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core'
import { Live, LiveCommentCount, LiveViewerCount2 } from 'src/lib/entity/live'
import { Magazine } from 'src/lib/entity/magazine'
import { Observable, interval, from } from 'rxjs'
import { map } from 'rxjs/operators'
import { FirestoreAccess } from 'src/lib/firestore-access'
import { CreatorCommentComponent } from 'src/app/parts/creator-comment/creator-comment.component'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import { Router } from '@angular/router'

type ViewerStatus =
  'NOT_LOGIN'
  | 'SUBSCRIBER'
  | 'NOT_SUBSCRIBER'

@Component({
  selector: 'maglive-player-header',
  templateUrl: './player-header.component.html',
  styleUrls: ['./player-header.component.scss'],
})
export class PlayerHeaderComponent {
  @Input() authority: LiveUserAuthority | undefined
  @Input() magazine: Magazine | string
  @Input() isFollowing: Boolean // チャンネル登録中かどうか
  @Input() live: Live
  @Input() viewerCount$: Observable<LiveViewerCount2 | object> // TODO: 処理を親からこっちに移設するかサービス化したい
  @Output() toggleVariantModalEvent = new EventEmitter<void>()
  @Output() toggleShareModalEvent = new EventEmitter<void>()
  @Output() onFollowClickEvent: EventEmitter<Boolean> = new EventEmitter()
  @ViewChild(CreatorCommentComponent) creatorCommentComponent: CreatorCommentComponent

  commentCount$: Observable<LiveCommentCount>
  viewerStatus: ViewerStatus
  spentTime$: Observable<string> | undefined
  liveStatusText: string
  magazineCoverImage: string

  constructor(
    private firestoreAccess: FirestoreAccess,
    private router: Router,
  ) {
  }

  ngOnInit() {
    // MEMO:チケット限定配信時にlive.idが取得できない可能性あるため条件分岐を一時的に外す
    // if (this.live.id) {
      this.commentCount$ = this.firestoreAccess.getCommentCount(this.live.id)
      this.makeLiveStatusText()
      this.checkViewerStatus()
      this.calcSpentTime()
    // }
    if (typeof this.magazine !== 'string') {
      this.magazineCoverImage = this.magazine.coverImage
    }
  }

  /**
   * 歯車ボタンの開閉
   */
  toggleVariantModal() {
    this.toggleVariantModalEvent.emit()
  }

  /**
   * クリエイターコメントの開閉
   */
  toggleCreatorComment() {
    this.creatorCommentComponent.toggleCreatorComment()
  }

  /**
   * シェアモーダル開閉
   */
  toggleShareModal() {
    this.toggleShareModalEvent.emit()
  }

  /**
   * チャンネル登録/解除の実行
   */
  onFollowClick(request: boolean) {
    this.onFollowClickEvent.emit(request)
  }

  /**
   * 新規タブでログインページに飛ばす
   */
  // moveLoginPage() {
  //   window.open(this.loginCallbackURL)
  // }

  /**
   * メルマガ画面へ飛ばす
   */
  moveMagazinePage() {
    if (typeof this.magazine !== 'string') {
      window.open(this.magazine.linkTop + '?reg=live_web_view')
    }
  }

  /**
   * 視聴者のステータスをチェックする
   */
  private checkViewerStatus() {
    if (typeof this.magazine === 'string') {
      this.magazine = null
    }
    if (!this.authority) {
      this.viewerStatus = 'NOT_LOGIN'
      return
    }
    if (this.isSubscriber()) {
      this.viewerStatus = 'SUBSCRIBER'
    } else {
      this.viewerStatus = 'NOT_SUBSCRIBER'
    }
  }

  /**
   * 視聴者が購読者かどうか判定する
   */
  private isSubscriber(): boolean {
    if (typeof this.magazine === 'string') {
      this.magazine = null
      return false
    }
    if (
      !this.authority.subscribingReleasedPaymentMagazineIds.includes(this.magazine.id)
      && !this.authority.publishingReleasedPaymentMagazineIds.includes(this.magazine.id)
      ) {
        return false
    } else {
      return true
    }
  }

  /**
   * 配信経過時間を計算する
   */
  calcSpentTime() {
    if (this.live.startedAt && (this.live.status === 'ON_AIR' || this.live.status === 'NO_STREAM')) {
      this.spentTime$ = interval(1000).pipe(map(() => {
        const spentTimeSecond = Math.floor((new Date().getTime() - this.live.startedAt.toDate().getTime()) / 1000)
        const seconds = spentTimeSecond % 60
        const minutes = (spentTimeSecond - seconds) % 3600 / 60
        const hours = (spentTimeSecond - seconds - (minutes * 60)) / 3600
        if (2 <= hours.toString().length) {
          return hours + ":" + ('00' + minutes).slice(-2) + ":" + ('00' + seconds).slice(-2);
        }
        return ('00' + hours).slice(-2) + ":" + ('00' + minutes).slice(-2) + ":" + ('00' + seconds).slice(-2);
      }))
    }
  }

  /**
   * ステータス表示用テキスト生成
   */
  makeLiveStatusText() {
    if (this.live.status === 'ON_AIR') {
      this.liveStatusText = 'LIVE'
    } else if (this.live.status === 'RESERVED') {
      this.liveStatusText = '準備中'
    } else {
      this.liveStatusText = ''
    }
  }

  onMagazineClick() {
    from(this.router.navigate(['magazines', this.live.magazineIdView])).subscribe()
  }
}
